<template>
  <inertia-link :href="href" :class="classes">
    <slot></slot>
  </inertia-link>
</template>

<script>
export default {
  props: ['href', 'active'],

  computed: {
    classes() {
      return this.active
        ? 'bg-white py-2 px-3 hover:bg-vice-light-grey font-bold rounded-md text-xs text-vice-teal-900 transition'
        : 'py-2 px-3 hover:text-base hover:bg-vice-teal-600 rounded-md  text-xs text-white transition';
    },
  },
};
</script>
